import { render, staticRenderFns } from "./rockId.vue?vue&type=template&id=6c7cc4a6&scoped=true&lang=pug&"
import script from "./rockId.vue?vue&type=script&lang=js&"
export * from "./rockId.vue?vue&type=script&lang=js&"
import style0 from "./rockId.vue?vue&type=style&index=0&id=6c7cc4a6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c7cc4a6",
  null
  
)

export default component.exports